var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showAsync
    ? _c(
        "async-component",
        _vm._g(
          _vm._b(
            {
              ref: _vm.refId,
              attrs: { url: _vm.url, obj: _vm.obj },
              on: {
                "execute-axios": _vm.executeAxios,
                "on-add-languages": _vm.addLanguages,
                "plugin-call-back": _vm.pluginCallBack,
              },
            },
            "async-component",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    : _c("div", [_c("h1", [_vm._v("未知组件无法展示")])])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }